import { Routes } from '@angular/router';

// Development version - includes demo imports
export function provideDemoRoutes(): Routes {
  return [
    {
      path: 'demo',
      loadChildren: () => import('./demo.routes').then((m) => m.demoRoutes),
    },
  ];
}
